export const CALCULATE_POSTCODE = 'CALCULATE_POSTCODE';
export const RESPONSE_ERROR = 'RESPONSE_ERROR';
export const EMAIL_RESULTS_SUCCESS = 'EMAIL_RESULTS_SUCCESS';
export const EMAIL_RESULTS_ERROR = 'EMAIL_RESULTS_ERROR';
export const EMAIL_SUCCESS_MESSAGE = 'EMAIL_SUCCESS_MESSAGE';
export const REMOVE_MESSAGE = 'REMOVE_MESSAGE';
export const NOT_FOUND_ERROR = 'NOT_FOUND_ERROR';